/**
 * QR Management Interfaces
 * Based on legacy QR components
 */

// ==================== QR Configuration ====================

export interface QrConfiguration {
  qr_id: number;
  qr_campaign_name: string;
  start_date: string;
  end_date: string;
  qr_desc: string;
  points_type_id: number;
  is_points_based_on_id: number;
  point_allocation_id: number; // 1=Brand, 2=Brand+Region, 3=Brand+Role+Region, 4=Brand+Role
  qr_tnc: string;
  is_credited_on_id:any;
  is_qr_type: number; // 1=Generate, 2=Import
  embed_code?: any;
  qrcode_length: number;
  status?: number;
  created_at?: string;
  updated_at?: string;
  created_by?: number;
  updated_by?: number;
}

// QR Configuration Form Data - matches legacy payload keys
export interface QrConfigFormData {
  qr_name: string; // Backend expects qr_name, not qr_campagin_name
  start_date: string;
  end_date: string;
  desc: string; // Backend expects desc, not qr_desc
  points_type: number | string; // Backend expects points_type, not points_type_id
  is_points_based_on: number | string; // Backend expects is_points_based_on, not is_points_based_on_id
  point_allocation_type: number | string; // Backend expects point_allocation_type, not point_allocation_id
  qr_tnc: string;
  is_credited_on_id: any;
  is_credited_on: any;
  is_qr_type: any;
  embed_code?: any;
  qrcode_length: number | string;
  qr_id?: number; // For update
  program_id?: number; // Added for API requirement
}

// ==================== Generated QR Item ====================

export interface QrCodeItem {
  id: number;
  qr_approve_id?: number;
  qr_code?: string;
  unique_code: string;
  points: number;
  sku?: string;
  brand_name?: string;
  expiry_date?: string;
  expriy_date?: string; // Legacy typo
  status: number; // 0=Pending, 1=Approved
  approval_status?: any; // '0'=Pending, '1'=Processing, '2'=Completed
  approval_request_status?: number; // 1=Processing, 2=Completed/Approved, 3=Rejected
  file_url?: string;
  zip_file_url?: string;
  zip_url?: string;
  excel_url?: string;
  url?: string;
  qr_campagin_name?: string;
  region_name?: string;
  qty?: number;
  created_at?: string;
  created_date?: string;
  updated_at?: string;
}

// ==================== Imported QR Item ====================

export interface ImportedQrItem {
  id: number;
  unique_code: string;
  points: number;
  sku?: string;
  brand_name?: string;
  expiry_date?: string;
  regions?: string;
  roles?: string;
  status: number;
  created_at?: string;
  updated_at?: string;
}

// ==================== QR Upload Response ====================

export interface QrUploadResponse {
  approved: number;
  rejected: number;
  rejectedList?: RejectedQrRecord[];
  message?: string;
}

// Rejected QR Record
export interface RejectedQrRecord {
  reason: string;
  message: string;
  row?: number;
  unique_code?: string;
}

// ==================== API Responses ====================

export interface QrConfigListResponse {
  status: number;
  data: QrConfiguration[];
  message?: string;
}

export interface QrConfigCreateResponse {
  status: number;
  data: {
    qr_id: number;
    message: string;
  };
  message?: string;
}

export interface QrListResponse {
  status: number;
  data: QrCodeItem[];
  message?: string;
}

export interface ImportedQrListResponse {
  status: number;
  data: ImportedQrItem[];
  message?: string;
}

export interface QrGenerateResponse {
  status: number;
  data: {
    approved: number;
    rejected: number;
    rejectedList?: RejectedQrRecord[];
  };
  message?: string;
}

export interface QrImportResponse {
  status: number;
  data: {
    approved: number;
    rejected: number;
    rejectedData?: RejectedQrRecord[];
    message: string;
  };
  message?: string;
}

export interface QrApproveResponse {
  status: number;
  data: {
    message: string;
  };
  message?: string;
}

// ==================== Enums ====================

export enum QrType {
  GENERATE = 1,
  IMPORT = 2,
}

export enum QrPointAllocationType {
  BRAND_ONLY = 1,
  BRAND_REGION = 2,
  BRAND_ROLE_REGION = 3,
  BRAND_ROLE = 4,
}

export enum QrStatus {
  PENDING = 0,
  APPROVED = 1,
}
